import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { useAcademicsService } from '../../../../apis/academics/useAcademicsService';
import { IAcademicsAssessmentClassMapResponse } from '../../../../apis/academics/academicsAssessments.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getAcademicsAssessmentsForClassesKey =
  'get-academics-assessments-for-classes';

export type TAcademicsAssessmentsParams = TPaginationParams & {
  academicYear?: string;
  grade?: string;
};

export const useAcademicsAssessmentsClassesHook = (
  params: TAcademicsAssessmentsParams,
  options?: UseQueryOptions<IAcademicsAssessmentClassMapResponse, TQueryError>
): UseQueryResult<IAcademicsAssessmentClassMapResponse, TQueryError> => {
  const { getAcademicsAssessmentsForClasses } = useAcademicsService();
  // TODO: Naman - Add academicYear, grade filters to assessments API
  return useQuery<IAcademicsAssessmentClassMapResponse, TQueryError>({
    queryKey: [getAcademicsAssessmentsForClassesKey, params],
    queryFn: () => getAcademicsAssessmentsForClasses(params),
    enabled: true,
    ...options,
  });
};
